<template>
  <div style="width: 100%">
    <div class="chart-header">
      <span>Comparecimento por Formação</span>
      <v-btn icon @click="toggleSort" style="margin-right: 2rem">
        <v-icon>mdi-sort</v-icon>
      </v-btn>
    </div>
    <div style="overflow-y: auto; width: 100%">
      <canvas ref="canvas" :height="height"></canvas>
    </div>
    
  </div>
</template>

<script>
import Chart from 'chart.js';

export default {
  name: 'HorizontalBarChart',
  props: {
    rawData: {
      type: Array,
      required: true
    },height: {
      type: [Number, String],
      default: 650
    }
  },
  data() {
    return {
      chart: null,
      sortDescending: true,
      labelPlugin: null
    };
  },
  watch: {
    rawData: {
      handler() {
        this.updateChart();
      },
      deep: true
    }
  },
  mounted() {
    this.renderChart();
  },
  methods: {
    toggleSort() {
      this.sortDescending = !this.sortDescending;
      this.updateChart();
    },

    registerPlugin() {

      this.labelPlugin = {
        afterDatasetsDraw: chart => {
          if (!chart.data.datasets || chart.data.datasets.length < 2) return;
          const ctx = chart.ctx;

          const presentesData = chart.data.datasets[0].data;
          const previstosData = chart.data.datasets[1].data;

          presentesData.forEach((presentes, i) => {
            const previstos = previstosData[i];

            let percent = previstos > 0 ? (presentes / previstos) * 100 : 0;
            percent = Math.min(percent, 100);

            const bar = chart.getDatasetMeta(0).data[i]; // ← dataset[0] é o de "Presentes"
            if (!bar) return;

            ctx.save();
            ctx.font = '10px Arial';
            ctx.fillStyle = '#222';
            ctx.textAlign = 'left';
            ctx.fillText(`${percent.toFixed(1)}%`, bar._model.x + 10, bar._model.y);
            ctx.restore();
          });
        }
      };
    },

    buildChartData() {
      const sorted = [...this.rawData].sort((a, b) => {
        const percA = a.presentes / (a.presentes + a.previstos || 1);
        const percB = b.presentes / (b.presentes + b.previstos || 1);
        return this.sortDescending ? percB - percA : percA - percB;
      });

      return {
        labels: sorted.map(f => f.nome),
        datasets: [
          {
            label: 'Presentes',
            backgroundColor: '#3F51B5',
            data: sorted.map(f => f.presentes),
            stack: 'stack1'
          },
          {
            label: 'Previstos',
            backgroundColor: '#4CAF50',
            data: sorted.map(f => f.previstos),
            stack: 'stack1'
          }
        ]
      };
    },

    getOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: 'bottom',
          labels: { fontSize: 12 }
        },
        scales: {
          xAxes: [
            {
              stacked: true,
              ticks: {
                beginAtZero: true,
                padding: 10
              }
            }
          ],
          yAxes: [
            {
              stacked: true,
              ticks: {
                padding: 10
              }
            }
          ]
        },
        layout: {
          padding: {
            right: 60
          }
        },
        tooltips: {
          mode: 'index',
          intersect: false
        }
      };
    },

    renderChart() {
      this.registerPlugin();
      if (this.chart) {
        this.chart.destroy();
        this.chart = null;
      }
      const chartData = this.buildChartData();
      this.chart = new Chart(this.$refs.canvas, {
        type: 'horizontalBar',
        data: chartData,
        options: this.getOptions(),
        plugins: [this.labelPlugin]
      });
    },

    updateChart() {
      this.renderChart();
    }
  }
};
</script>

<style scoped>
.chart-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
}
</style>